import { useExtDocumentMeta } from '../../../api/extDocumentMeta';

/**
 * Hook to control document signatures page
 *
 * @param docSlug - document slug
 */
export const useExtDocumentSignaturesController = (docSlug: string) => {
  /**
   * Get document meta
   */
  const query = useExtDocumentMeta(docSlug);

  /**
   * Document stage
   */
  const finished = query.data?.data?.finished;

  /**
   * Filtered signatures that are done and have a date
   * When signature not has a date and is done, it means that the signature is skipped in group
   */
  const signatures = (query.data?.data?.signatures || []).filter(item =>
    finished ? item.done && item.date : true,
  );

  return {
    ...query,
    data: query.data,
    signatures,
    finished,
  };
};
